import { normalizarCuit } from './formatearCuit.js'

const incluyeTexto = (valor, termino) =>
  String(valor ?? '')
    .toLowerCase()
    .includes(termino)

/**
 * Filtra las cuentas por razón social, CUIT, contrato o póliza (criterio 7).
 * Match parcial, sin distinguir mayúsculas.
 *
 * El CUIT se compara dos veces: contra el valor tal cual viene y contra sus
 * dígitos pelados, para que "30-12345678-9" se encuentre escribiendo
 * "30123456789" y al revés — la grilla lo muestra formateado pero el backend
 * lo devuelve sin separadores.
 *
 * @param {Array<{razonSocial?: string, cuit?: string, contrato?: number|string, poliza?: string|number}>} cuentas
 * @param {string} busqueda
 * @returns {Array} las cuentas que coinciden; el mismo array si no hay filtro
 */
export function filtrarCuentas(cuentas, busqueda) {
  if (!Array.isArray(cuentas)) return []

  const termino = String(busqueda ?? '')
    .trim()
    .toLowerCase()

  if (!termino) return cuentas

  const terminoDigitos = termino.replace(/\D/g, '')

  return cuentas.filter((cuenta) => {
    if (incluyeTexto(cuenta?.razonSocial, termino)) return true
    if (incluyeTexto(cuenta?.contrato, termino)) return true
    if (incluyeTexto(cuenta?.poliza, termino)) return true
    if (incluyeTexto(cuenta?.cuit, termino)) return true

    return terminoDigitos.length > 0 && normalizarCuit(cuenta?.cuit).includes(terminoDigitos)
  })
}
